module.exports = __webpack_public_path__ + "static/media/icon_190.978b81bc.svg";